import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NoneAccountingCodesNotificationModule } from '../../../../cms-components/misc/none-accounting-codes-notification/none-accounting-codes-notification.module';
import { I18nModule } from '../../../../core/i18n';
import { UrlModule } from '../../../../core/routing';
import {
  AddToOrderCardModule,
  CounterInputModule,
  DrawerModule,
  GenericLinkModule,
  MessageBannerModule,
  NavSideScrollModule,
  PipesModule,
  PrincipalConfigurationDirectiveModule,
  ResponsiveTableModule,
} from '../../../../shared';
import { BadgeModule } from '../../../../shared/components/badge';
import { CartEntriesTableModule } from '../../../../shared/components/cart-entries-table/cart-entries-table.module';
import { CreateShoppingListModalModule } from '../../../../shared/components/create-shopping-list-modal/create-shopping-list-modal.module';
import { NotificationModule } from '../../../../shared/components/notification';
import { TinyMultipleCartBadgeModule } from '../../../../shared/components/tiny-cart-badge/tiny-multiple-cart-badge.module';
import { ScreenSizeModule } from '../../../../shared/directives/screen-size/screen-size.module';
import { CartEmptyNotificationModule } from '../../components/cart-empty-notification';
import { EmptyCartModalModule } from '../../components/empty-cart-modal';
import { CartDrawerComponent } from './cart-drawer.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    NzIconModule,
    I18nModule,
    ScreenSizeModule,
    TinyMultipleCartBadgeModule,
    ResponsiveTableModule,
    CounterInputModule,
    CartEntriesTableModule,
    DrawerModule,
    NotificationModule,
    UrlModule,
    CartEmptyNotificationModule,
    GenericLinkModule,
    PrincipalConfigurationDirectiveModule,
    AddToOrderCardModule,
    MessageBannerModule,
    NoneAccountingCodesNotificationModule,
    NgbNavModule,
    BadgeModule,
    NavSideScrollModule,
    CreateShoppingListModalModule,
    NgbTooltipModule,
    EmptyCartModalModule,
  ],
  declarations: [CartDrawerComponent],
  exports: [CartDrawerComponent],
})
export class CartDrawerModule {}
